module.exports = __webpack_public_path__ + "static/img/index_light_des_image.d92f875.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_light_des_image.png
// module id = yHc6
// module chunks = 1